export const lifecycleVulnerabilityTags = [
    "UNPROVEN",
    "EXISTS",
    "MALWARE",
    "MANDATE",
];
export const activeVulnerabilityTags = [
    ...lifecycleVulnerabilityTags,
    "FIXABLE",
];
export const triagedVulnerabilityTags = ["TRIAGED"];
export const exploitPresence = [
    ...activeVulnerabilityTags,
    ...triagedVulnerabilityTags,
];
export const issueEstimate = ["low", "medium", "high"];
export const releaseStatus = ["pass", "fail"];
export const softwareGrade = ["A", "B", "C", "D", "F"];
export const priority = ["P0", "P1", "P2", "P3", "P4"];
export const classification = [
    "Unknown",
    "Goodware",
    "Suspicious",
    "Malicious",
    "",
];
export const dependencyLinking = ["static", "dynamic", "package"];
export const toolchainType = [
    "compiler",
    "linker",
    "resource",
    "profiler",
    "instrumentation",
    "interpreter",
];
export const softwareType = [
    "unknown",
    "application",
    "service",
    "library",
    "package",
    "container",
    "firmware",
    "script",
    "bundle",
    "ml-model",
    "extension",
];
export const formatCategory = [
    "software",
    "mobile",
    "script",
    "source",
    "archive",
    "document",
    "email",
    "multimedia",
    "ml-model",
    "other",
];
export const install = ["mandatory", "optional"];
export const scenario = ["develop", "release"];
export const community = [
    "general",
    "windows",
    "linux",
    "macos",
    "containers",
    "managed",
    "python",
    "java",
    "ruby",
    "nodejs",
    "go",
    "rust",
    "php",
    "vscode",
    "ai",
    "powershell",
];
export const identityVerification = [
    "Not verified",
    "User override",
    "SHA-256",
    "Authentihash",
    "Certificate",
    "Cloud source",
    "Byte Pattern",
    "Similarity",
    "Manifest",
];
export const languageDetector = ["signature", "linguist", "heuristic"];
export const storyArgument = [
    "externalLink",
    "internalLink",
    "searchQuery",
];
export const diffChange = ["changed", "added", "removed"];
export const diffObject = [
    "name",
    "hash",
    "format",
    "policy",
    "classification",
    "vulnerability",
    "dependency",
    "indicator",
    "functionality",
    "toolchain",
    "entropy",
    "tag",
    "size",
    "action",
    "uri",
];
export const diffReproCheck = [
    "repro-not-checked",
    "repro-check-pass",
    "repro-check-fail",
];
export const assessmentStatus = ["pass", "warning", "fail"];
export const assessment = [
    "licenses",
    "secrets",
    "vulnerabilities",
    "hardening",
    "tampering",
    "malware",
];
export const reportType = ["CI", "DF", "RB"];
export const networkFlow = ["inbound", "bidirectional", "outbound"];
export const networkService = [
    "data-generic",
    "data-provider",
    "data-processor",
    "data-exchange",
    "data-forwarder",
    "voip-provider",
    "user-identity",
    "user-finance",
    "user-location",
    "user-tracking",
    "chat-exchange",
    "mail-exchange",
    "file-exchange",
    "code-provider",
    "code-processor",
    "push-provider",
];
export const secretLiveness = [
    "skipped",
    "site-unknown",
    "site-offline",
    "site-timeout",
    "rate-limited",
    "site-error",
    "active",
    "inactive",
];
export const prevalence = [
    "behavior-malicious",
    "behavior-important",
    "behavior-anomalous",
    "behavior-uncommon",
    "behavior-common",
];
export const relevance = ["high", "low", "none"];
export const mlParamType = [
    "none",
    "class",
    "text",
    "binary",
    "image",
    "audio",
    "video",
    "signal",
    "action",
    "code",
    "logs",
    "graph",
];
export const mlApproach = [
    "undeclared",
    "supervised",
    "self-supervised",
    "unsupervised",
    "semi-supervised",
    "reinforcement-learning",
];
// Keep order from <internal source control server>/core/sdlc-schema/blob/master/cpp-schemas/sdlc-report.h#L37
export const licenseFamily = [
    "",
    "Public domain",
    "Permissive",
    "Weak Copyleft",
    "Copyleft",
    "Freeware",
    "Shareware",
    "Freemium",
    "Non-commercial",
    "Proprietary",
];
export const cryptoMaterial = [
    "secret-key",
    "private-key",
    "public-key",
    "ciphertext",
    "signature",
];
export const cryptoSource = [
    "pattern",
    "behavior",
    "material",
    "certificate",
    "protocol",
];
export const cryptoFunction = [
    "generic",
    "generate",
    "keygen",
    "encrypt",
    "decrypt",
    "encapsulate",
    "decapsulate",
    "digest",
    "sign",
    "verify",
    "keyderive",
    "tag",
];
export const cryptoOperation = [
    "unknown",
    "cbc",
    "ecb",
    "ccm",
    "gcm",
    "cfb",
    "ofb",
    "ctr",
];
export const cryptoPrimitive = [
    "unknown",
    "drbg",
    "mac",
    "block-cipher",
    "stream-cipher",
    "signature",
    "hash",
    "ae",
    "pke",
    "xof",
    "kdf",
    "kem",
    "key-agree",
    "combiner",
];
export const actionType = [
    "open-file",
    "create-file",
    "change-file",
    "copy-file",
    "rename-file",
    "remove-file",
    "download-file",
    "open-hyperlink",
    "create-process",
    "create-shortcut",
    "change-registry",
    "change-settings",
    "change-startup",
    "install-software",
    "remove-software",
    "install-driver",
    "remove-driver",
    "install-firmware",
    "remove-firmware",
    "start-service",
    "stop-service",
    "use-hardware",
    "use-network",
];
export const eventType = [
    "document-open",
    "document-input",
    "document-signing",
    "document-print",
    "document-sync",
    "document-close",
    "software-custom",
    "software-deploy",
    "software-compile",
    "software-execute",
    "software-packing",
    "software-signing",
    "software-testing",
    "software-publish",
    "software-update",
    "software-remove",
];
//# sourceMappingURL=sdlcMetadataConstants.js.map